<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Contact Information:">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>       
            </FormSection>
            <div>
            <AmountSelectorStlConcert />
          </div>  

          <div class="total__amt">
            <label>Total: </label>  
            <MoneyFormat
              v-if="form.amount"
              class="amount"
              :value="totalAmount"
              :currencyCode="form.currency"
            />
          </div>

            <FormSection title="">
            <h4>Please let us know about any special dietary needs you have</h4>
            <FormRow>
                <input type="checkbox" @click="setValue('custom.isGlutenFree', !isGlutenFree)" :checked="isGlutenFree" id="isGlutenFree" class="checkbox-input"/>  <FormLabel for="isGlutenFree"> Gluten Free</FormLabel>
              </FormRow> 
            <FormRow>
                <input type="checkbox" @click="setValue('custom.isVegetarian', !isVegetarian)" :checked="isVegetarian" id="isVegetarian" class="checkbox-input"/>  <FormLabel for="isVegetarian"> Vegetarian</FormLabel>
              </FormRow> 
              <br>
              <FormRow inline>
                    <FormCol field="custom.comments">
                      <FormInput type="textarea" />
                    </FormCol>
              </FormRow>
            
          </FormSection>
        
          <FormSection title="Billing Info:">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information:" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>

          <PaymentButton showAmount btnText="Pay now" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, onMounted } from "vue";
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({  props: {
    subCampaign: String,
    campaign: String,
  },
  setup(props) {
    const { getValue, setValue, form, submit } = usePaymentForm();
    const isGlutenFree = computed(() => getValue('custom.isGlutenFree'))
    const isVegetarian = computed(() => getValue('custom.isVegetarian'))

    const totalAmount = computed(() =>
      form.value.handleProcessing
        ? Math.round((+form.value.amount! + +form.value.amount! * 0.025) * 100) / 100
        : +form.value.amount!
    );

    if (props.subCampaign) {
      setValue("applications.0.subCampaign", props.subCampaign);
    }

    if (props.campaign) {
      setValue("applications.0.campaign", props.campaign);
    }

    onMounted(() => {
      const params = queryParams();

      if (params.utm_content) {
        if (
          !["Direct Mail", "Telemarketing", "Text SMS Message"].includes(
            params.utm_content
          )
        ) {
          throw new Error("Invalid subcampaign");
        }

        setValue("applications.0.subCampaign", params.utm_content);
      }
    });

    return {
      form,
      getValue,
      setValue,
      submit,
      totalAmount,
      isGlutenFree,
      isVegetarian,
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep hr {
  display: block !important;
  border-color: #efefef !important;
  margin-top: 0 !important;
  margin-bottom: 30px !important;
}
::v-deep h2 {
  font-size: 26px !important;
    line-height: 40px !important;
    margin-bottom: 20px !important; 
    text-align: left !important;
}
.paytext {
  font-size: 14px;
  color: #222;
  padding-top: 0px;
  line-height: normal;
  padding-bottom: 10px;
  display: block;
}
#isGlutenFree,
#isVegetarian {
  margin-right: 5px;
}

h4{
  font-size: 14px;
    font-weight: 400;
    margin-bottom: 20px;
    margin-top: -10px;
}

.total__amt {
    display: flex;
    gap: 7px;
    font-size: 19px;
    padding-bottom: 20px;
    label{
      font-weight: 600;
    }
}

::v-deep .control-label {
    text-align: left !important;
    font-weight: 400 !important;
    font-weight: 300 !important;
}
::v-deep .form-group {
    margin-right: 0px !important;
    margin-left: 0px !important;
}
</style>
